var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogomarkCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 81,
    r: 81,
    fill: "#F7EAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.735 49.2079C132.724 49.2189 132.713 49.2189 132.713 49.2419L132.69 49.2639C132.656 49.2989 132.644 49.3099 132.656 49.3099L99.9647 83.6599L92.2647 91.7529C92.2509 91.7427 92.2353 91.7353 92.2187 91.7309L92.0827 91.6629L60.5967 77.6129L61.7447 77.0789L67.0527 74.5899L74.4527 71.1229C74.4658 71.1119 74.4812 71.104 74.4977 71.0999H74.5097L129.73 45.2409C130.257 44.9934 130.854 44.9345 131.42 45.0741C131.985 45.2137 132.486 45.5434 132.838 46.0079C133.19 46.4725 133.372 47.0437 133.353 47.6262C133.334 48.2087 133.116 48.7671 132.735 49.2079Z",
    fill: "url(#paint0_linear_51_502)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4215 66.3831H28.4335C28.4215 66.3941 28.4215 66.4051 28.4105 66.4171C28.4097 66.4109 28.4102 66.4047 28.4121 66.3988C28.4141 66.3929 28.4173 66.3875 28.4215 66.3831Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2688 91.753C92.2688 91.753 91.2338 91.378 89.4378 90.696C87.6378 89.98 85.0728 89.026 82.0158 87.775C78.9578 86.547 75.3998 85.081 71.6158 83.467C67.8318 81.853 63.8068 80.08 59.7828 78.307C57.7828 77.397 55.7828 76.499 53.8158 75.601C51.8488 74.726 49.9278 73.801 48.0528 72.942C44.3248 71.202 40.8578 69.542 37.9019 68.077C36.4129 67.36 35.0718 66.677 33.8668 66.065C33.2758 65.765 32.7078 65.473 32.2068 65.235C31.7571 65.0232 31.2586 64.9369 30.7639 64.985C30.0467 65.0502 29.3748 65.3636 28.8638 65.871C28.819 65.9136 28.7772 65.9594 28.7388 66.008C28.7038 66.042 28.6699 66.087 28.6389 66.121C28.6056 66.1516 28.5752 66.1851 28.5479 66.221C28.9461 65.5778 29.5666 65.1033 30.2916 64.8874C31.0166 64.6715 31.7957 64.7294 32.4808 65.05L60.6028 77.61L61.7508 77.076C65.3508 78.701 68.9458 80.327 72.3108 81.907C76.0388 83.646 79.5058 85.317 82.4718 86.772C85.4378 88.227 87.8718 89.488 89.5878 90.352C90.8718 91.012 91.7358 91.466 92.0878 91.66L92.2238 91.728C92.2403 91.7334 92.2555 91.7419 92.2688 91.753Z",
    fill: "black"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2692 91.753L79.8692 104.791C79.8605 104.801 79.8531 104.813 79.8472 104.825C79.8472 104.825 79.8352 104.814 79.8352 104.825L69.9462 115.225C69.8031 115.377 69.6516 115.522 69.4922 115.657C68.8701 116.184 68.1457 116.577 67.3645 116.81C66.5833 117.044 65.7622 117.113 64.9529 117.014C64.1436 116.914 63.3637 116.649 62.6621 116.233C61.9605 115.818 61.3524 115.262 60.8762 114.6L41.1542 87.206V87.195C41.1312 87.183 41.1312 87.172 41.1312 87.172L40.8932 86.842L28.6172 69.803C28.2619 69.3316 28.0503 68.7676 28.0079 68.1787C27.9655 67.5899 28.0941 67.0014 28.3782 66.484C28.3888 66.4706 28.3966 66.4553 28.4012 66.439C28.4028 66.439 28.4043 66.4387 28.4057 66.4381C28.4071 66.4374 28.4084 66.4365 28.4094 66.4354C28.4104 66.4343 28.4112 66.4329 28.4117 66.4315C28.4122 66.43 28.4124 66.4285 28.4122 66.427V66.416C28.4114 66.4098 28.4119 66.4036 28.4138 66.3977C28.4157 66.3918 28.4189 66.3864 28.4232 66.382H28.4352C28.4572 66.336 28.5032 66.291 28.5482 66.223C28.9464 65.5798 29.567 65.1052 30.292 64.8893C31.017 64.6735 31.7961 64.7314 32.4812 65.052L60.6032 77.612L92.0892 91.662L92.2253 91.73C92.2411 91.7348 92.2561 91.7426 92.2692 91.753Z",
    fill: "url(#paint1_linear_51_502)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9647 83.6601L92.2647 91.7531C92.2509 91.7429 92.2353 91.7354 92.2187 91.7311L60.5967 77.6131L61.7447 77.0791L67.0527 74.5901L99.9647 83.6601Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4215 66.3831H28.4335C28.4215 66.4051 28.4105 66.4171 28.4105 66.4281C28.4089 66.4123 28.4128 66.3964 28.4215 66.3831Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2688 91.753C92.2688 91.753 91.2338 91.378 89.4378 90.696C87.6378 89.98 85.0728 89.026 82.0158 87.775C78.9578 86.547 75.3998 85.081 71.6158 83.467C67.8318 81.853 63.8068 80.08 59.7828 78.307C57.7828 77.397 55.7828 76.499 53.8158 75.601C51.8488 74.726 49.9278 73.801 48.0528 72.942C44.3248 71.202 40.8578 69.542 37.9019 68.077C36.4129 67.36 35.0718 66.677 33.8668 66.065C33.2758 65.765 32.7078 65.473 32.2068 65.235C31.7571 65.0232 31.2586 64.9369 30.7639 64.985C30.0467 65.0502 29.3748 65.3636 28.8638 65.871C28.819 65.9136 28.7772 65.9594 28.7388 66.008C28.7023 66.0427 28.6689 66.0806 28.6389 66.121C28.6056 66.1516 28.5752 66.1851 28.5479 66.221C28.9461 65.5778 29.5666 65.1033 30.2916 64.8874C31.0166 64.6715 31.7957 64.7294 32.4808 65.05L60.6028 77.61L92.0888 91.66L92.2248 91.728C92.2409 91.7335 92.2558 91.742 92.2688 91.753Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8333 104.825L69.9443 115.225C69.8012 115.377 69.6496 115.522 69.4903 115.657C68.8682 116.184 68.1438 116.577 67.3626 116.81C66.5814 117.044 65.7603 117.113 64.951 117.014C64.1418 116.914 63.3618 116.649 62.6602 116.233C61.9586 115.818 61.3505 115.262 60.8743 114.6L41.1523 87.2061C41.2893 87.3541 41.8573 88.0241 42.7523 89.1061C43.7523 90.3561 45.2303 92.1181 46.9243 94.2781C48.6183 96.4381 50.5843 98.9721 52.6413 101.723C54.7103 104.451 56.8583 107.423 59.0183 110.373L60.6093 112.613L61.3933 113.726L61.5983 113.999C61.6502 114.079 61.7073 114.155 61.7693 114.227C61.8892 114.39 62.0231 114.542 62.1693 114.681C62.6933 115.211 63.3275 115.619 64.0269 115.876C64.7263 116.134 65.4738 116.234 66.2163 116.17C66.9424 116.11 67.6476 115.897 68.2853 115.545C68.5905 115.377 68.8762 115.176 69.1373 114.945L69.3653 114.752L69.4553 114.672L69.5553 114.558L69.9753 114.149C71.0893 113.035 72.1583 112.001 73.1583 111.049C75.1253 109.139 76.8303 107.605 77.9893 106.491C79.0283 105.545 79.6863 104.945 79.8333 104.825Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.042 48.662C133.181 48.3477 133.25 48.0063 133.242 47.6624C133.234 47.3185 133.15 46.9807 132.997 46.673C132.793 46.2147 132.441 45.8377 131.998 45.6022C131.556 45.3666 131.047 45.2859 130.553 45.373C129.931 45.5787 129.336 45.8574 128.78 46.203C128.132 46.532 127.45 46.885 126.744 47.248C123.903 48.715 120.573 50.386 116.992 52.148C115.192 53.012 113.344 53.948 111.445 54.83C109.546 55.712 107.638 56.638 105.717 57.547C101.852 59.347 97.9866 61.127 94.3376 62.753C90.6886 64.379 87.2796 65.867 84.3376 67.106C81.3936 68.368 78.9155 69.334 77.1875 70.05C75.6985 70.65 74.7436 71.005 74.5166 71.096L129.737 45.237C130.264 44.9919 130.859 44.9349 131.424 45.0754C131.988 45.216 132.487 45.5457 132.838 46.0095C133.189 46.4734 133.37 47.0434 133.351 47.6247C133.333 48.2059 133.116 48.7633 132.737 49.204C132.858 49.0352 132.96 48.8534 133.042 48.662Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.428 48.355L126.279 52.709C123.29 55.8463 120.304 58.9834 117.322 62.12L76.1064 72.862C85.7684 68.338 95.4351 63.814 105.106 59.29C112.801 55.69 120.501 52.083 128.206 48.469C128.945 48.128 129.684 47.775 130.423 47.434C131.328 47.002 130.813 47.945 130.428 48.355Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4155 92.5151C86.5281 94.4825 84.6488 96.4564 82.7775 98.4371C82.2545 98.9831 81.7325 99.5371 81.2095 100.085L31.2285 67.0991C31.8035 67.2015 32.3545 67.4097 32.8535 67.7131C40.9475 71.3271 49.0445 74.9418 57.1445 78.5571C67.5691 83.2158 77.9928 87.8685 88.4155 92.5151Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_502",
    x1: 40.8794,
    y1: 68.3765,
    x2: 133.354,
    y2: 68.3765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8007A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_502",
    x1: 84.8782,
    y1: 81.5482,
    x2: 39.5601,
    y2: 99.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.162,
    stopColor: "#FBC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#FBB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#FBA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#FA8900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#FA6800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842,
    stopColor: "#F93F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967,
    stopColor: "#F81000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F80300"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomarkCircle);
export default __webpack_public_path__ + "static/media/LogomarkCircle.f6793e86401cc14cadfd2804980c763a.svg";
export { ForwardRef as ReactComponent };